import { render, staticRenderFns } from "./FuelFundsLayout.vue?vue&type=template&id=6ef1bceb&"
import script from "./FuelFundsLayout.vue?vue&type=script&lang=js&"
export * from "./FuelFundsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef1bceb')) {
      api.createRecord('6ef1bceb', component.options)
    } else {
      api.reload('6ef1bceb', component.options)
    }
    module.hot.accept("./FuelFundsLayout.vue?vue&type=template&id=6ef1bceb&", function () {
      api.rerender('6ef1bceb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/FuelFundsLayout.vue"
export default component.exports